var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['time_counter_box flex-row', {ending: _vm.isTimerEndingActive}]},[_c('base-image',{attrs:{"src":_vm.timerIcon}}),_vm._v(" "),_c('div',{class:['time_counter', {ending: _vm.isTimerEndingActive}]},[_vm._v("\n    "+_vm._s(_vm._f("formatTimerFilter")(_vm.timerInSeconds))+"\n  ")])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-85cabf20","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/game/addOnGame/components/AddOnGameTimer.vue
// module id = null
// module chunks = 